/* tslint:disable */
/* eslint-disable */
/**
 * Project Client API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ClientCompanyMemberResource } from './';
import {
    ClientCompanyMemberResourceFromJSON,
    ClientCompanyMemberResourceFromJSONTyped,
    ClientCompanyMemberResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface ClientCompanyMembersListResource
 */
export interface ClientCompanyMembersListResource {
    /**
     * 
     * @type {Array<ClientCompanyMemberResource>}
     * @memberof ClientCompanyMembersListResource
     */
    members?: Array<ClientCompanyMemberResource>;
}

/**
 * Check if a given object implements the ClientCompanyMembersListResource interface.
 */
export function instanceOfClientCompanyMembersListResource(value: object): value is ClientCompanyMembersListResource {
    return true;
}

export function ClientCompanyMembersListResourceFromJSON(json: any): ClientCompanyMembersListResource {
    return ClientCompanyMembersListResourceFromJSONTyped(json, false);
}

export function ClientCompanyMembersListResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientCompanyMembersListResource {
    if (json == null) {
        return json;
    }
    return {
        
        'members': json['members'] == null ? undefined : ((json['members'] as Array<any>).map(ClientCompanyMemberResourceFromJSON)),
    };
}

export function ClientCompanyMembersListResourceToJSON(value?: ClientCompanyMembersListResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'members': value['members'] == null ? undefined : ((value['members'] as Array<any>).map((v) => ClientCompanyMemberResourceToJSON(v))),
    };
}

